import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { messages } from "./messages";

const headerStyle = css({
    fontFamily: token("font.family.brand.heading"), // Charlie Display
    fontWeight: 800,
    fontSize: "48px",
    lineHeight: "56px",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    marginBlockStart: "63px"
});

const subHeaderStyle = css({
    fontFamily: token("font.family.brand.body"), // Charlie Text
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    margin: "8px 0 0 0"
});

export const PaidJiraAiHeader = () => {
    return (
        <>
            <h1 css={headerStyle}>
                <FormattedMessage {...messages.getToDoneFaster} />
            </h1>
            <p css={subHeaderStyle}>
                <FormattedMessage {...messages.aiPoweredProjectManagement} />
            </p>
        </>
    );
};
